import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ExposedUpdateMortgageEligibilityPropertyInfoReq } from 'app/interfaces/requests/Exposed/exposedUpdateMortgageEligibilityPropertyInfoReq';
import { DialogGeneral } from '../../../DialogGeneral';

export interface DialogMortgageEligibilityConfirmFetchPropertyInfoData {
    propertyInfoLastFetchedAt: Date;
    propertyEncumbranceInfoLastFetchedAt: Date;
}

@Component({
    selector: 'dialog-mortgage-eligibility-confirm-fetch-property-info',
    templateUrl: 'dialog-mortgage-eligibility-confirm-fetch-property-info.html',
    encapsulation: ViewEncapsulation.None,
})
export class DialogMortgageEligibilityConfirmFetchPropertyInfoComponent extends DialogGeneral {
    form: FormGroup;

    /**
     * Constructor
     */
    constructor(
        public dialogRef: MatDialogRef<null>,
        public dialog: MatDialog,
        private formBuilder: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA)
        public data: DialogMortgageEligibilityConfirmFetchPropertyInfoData
    ) {
        super(dialogRef);
        this.initForm();
    }

    initForm = () => {
        this.form = this.formBuilder.group({
            refreshPropertyInfoDocument: new FormControl(true),
            refreshPropertyEncumbranceInfoDocument: new FormControl(true),
            refreshPropertyData: new FormControl(true),
            updatePropertyData: new FormControl(true),
        });

        // If there is no previous data the user will always have to fetch all data
        if (this.data.propertyInfoLastFetchedAt == null && this.data.propertyEncumbranceInfoLastFetchedAt == null) {
            this.form.disable();
        }
    };

    cancel = () => {
        this.dialogRef.close(null);
    };

    submit = () => {
        let refreshPropertyData = this.form.get('refreshPropertyData').value;
        // If data is not being refreshed the document property data is always updated
        let updatePropertyData = (refreshPropertyData && this.form.get('updatePropertyData').value) || !refreshPropertyData;
        let refreshPropertyInfoDocument = refreshPropertyData && this.form.get('refreshPropertyInfoDocument').value;
        let refreshPropertyEncumbranceInfoDocument = refreshPropertyData && this.form.get('refreshPropertyEncumbranceInfoDocument').value;

        this.dialogRef.close({
            updatePropertyData,
            refreshPropertyData,
            refreshPropertyEncumbranceInfoDocument,
            refreshPropertyInfoDocument,
        } as ExposedUpdateMortgageEligibilityPropertyInfoReq);
    };
}
